<script>
export default {
  name: "WNav",
  computed: {
    navs: function () {
      return this.$store.getters.website_nav;
    },
    first_path: function () {
      return this.$store.getters.first_path;
    },
  },
  data() {
    return {
      offsetLeft: 0
    }
  },
  methods: {
    handleMouseIn(event) {
      this.offsetLeft = event.target.offsetLeft;
      this.$bus.$emit("SHOW-MORE-MENU", event.target.offsetLeft);
    },
    handleMouseOut() {
      this.$bus.$emit("HIDE-MORE-MENU");
    },
    handleNav(nav) {
      this.$bus.$emit("SHOW-MORE-MENU", this.offsetLeft);
      if(nav.path != '/') return
      if (!nav.children || !!nav.children.length) {
        if (!nav.path) return;

        if (nav.id) return null;
        if (nav.path === '/college-introductions') return null;

        this.handleMouseOut();
        return this.$router.push(nav.path);
      }
    },
  },
};
</script>

<template>
  <div class="w-nav" @mouseenter="handleMouseIn" @mouseleave="handleMouseOut">
    <div
        class="w-nav-item"
        :class="{
      'w-nav-item-active': first_path === nav.path
        }"
        @click.stop="handleNav(nav)"
        v-for="(nav, index) in navs"
        :key="index"
    >
      {{ nav.title }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.w-nav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;

  .w-nav-item {
    width: var(--app-header-menu-item-width);
    max-width: var(--app-header-menu-item-width);
    height: var(--app-header-nav-height);
    line-height: var(--app-header-nav-height);
    cursor: pointer;
    text-align: center;
    transition: color 0.1s, width 0.2s;
    user-select: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    &:hover {
      color: #D4062E;
    }

    &.w-nav-item-active {
      color: #D4062E;
      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        background-color: #DB062F;
        height: 5px;
        z-index: 2003;
        border-radius: 10px;
      }
    }

  }
}
</style>
